'use strict';

import _ from 'lodash';
import React, { Component, PropTypes } from 'react';

import './../../scss/components/_searchbar.scss';

export default class SearchBar extends Component {

	constructor(props) {
		super(props);

		this.state = {
			value: this.props.value || props.initialValue || '',
		};

		this.handleInput = this.handleInput.bind(this);
		this.handleKey = this.handleKey.bind(this);
		this.hideIcon = this.hideIcon.bind(this);
		this.showIcon = this.showIcon.bind(this);
	}

	componentWillReceiveProps (nextProps) {

		// Update the value if the `value` prop changes
		if (this.state.value != nextProps.value) {
			this.setState({ value: nextProps.value });
		}

	}

	hideIcon(e) {
		this.refs.icon.className = '';
	}

	showIcon(e) {
		this.refs.icon.className = 'searchbar-icon';
	}

	handleInput(e) {
		this.setState({ value: e.target.value });
	}

	handleKey(e) {
		let code = e.which || e.keyCode;
		//13 = Carriage Return/Enter Key
		if(code === 13) {
			this.props.onEnter(this.state.value);
		}
	}

	render () {

		const props = _.without(this.props, [
			'value',
			'placeholder',
			'onEnter',
			'onChange',
			'onKeyPress',
			'onFocus',
			'onBlur',
		]);

		return (
			<div className="searchbar">
				<input
					{ ...props }
					value={this.state.value}
					placeholder='Search'
					onChange={this.handleInput}
					onKeyPress={this.handleKey}
					onFocus={this.hideIcon}
					onBlur={this.showIcon} />
				<span ref="icon" className="searchbar-icon"></span>
			</div>
		);
	}
}

SearchBar.propTypes = {
	onEnter: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/assets/js/components/SearchBar.js